var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    width: 446.6667,
    height: 510.3333,
    viewBox: "590 150 446.6667 510.3333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-850.11084,-850.11084,0,641.04346,660.45654)",
    spreadMethod: "pad",
    id: "linearGradient28"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#363941"
    },
    offset: 0,
    id: "stop22"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#252a34"
    },
    offset: 0.768156,
    id: "stop24"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#252a34"
    },
    offset: 1,
    id: "stop26"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,769 H 1280 V 0 H 0 Z",
    id: "path36"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1025.3333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g34",
    clipPath: "url(#clipPath38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g84",
    transform: "translate(750.4595,565.6724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -14.69,1.546 -25.516,-4.639 -25.516,-4.639 -4.492,22.453 -29.257,56.49 -103.755,48.139 -2.474,-0.278 -5.002,-0.603 -7.584,-0.974 -80.413,-11.598 -81.959,45.619 -81.959,45.619 47.938,-38.66 49.484,-24.743 130.67,-27.062 C -23.172,59.227 -5.737,21.217 -1.369,6.116 -0.278,2.343 0,0 0,0",
    style: {
      fill: "#f5c9b4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g88",
    transform: "translate(750.4595,565.6724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -14.69,1.546 -25.516,-4.639 -25.516,-4.639 -4.492,22.453 -29.257,56.49 -103.755,48.139 0,0 87.905,24.928 108.781,-38.474 l 19.121,1.09 C -0.278,2.343 0,0 0,0",
    style: {
      fill: "#656e7e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g92",
    transform: "translate(769.7197,485.1675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -10.956,-27.178 -37.043,-34.701 -37.043,-34.701 22.035,37.5 -5.026,56.83 -16.624,61.469 -3.596,1.438 -4.74,5.992 -3.82,11.575 1.462,8.923 8.188,20.466 18.58,26.072 4.082,2.196 8.729,3.479 13.848,3.333 C -9.255,67.284 -1.701,51.317 1.817,38.652 5.366,25.895 4.949,12.286 0,0",
    style: {
      fill: "#ba8b7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g96",
    transform: "translate(746.207,463.2241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 10.708,40.84 -24.371,56.752 -33.974,60.286 1.461,8.923 8.188,20.466 18.579,26.072 C 49.917,52.809 0,0 0,0",
    style: {
      fill: "#f8ccb2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g100",
    transform: "translate(704.4546,508.0693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0 6.186,-13.144 25.515,-23.969 0,0 -9.557,-7.765 -19.746,-3.87 -2.758,1.054 -4.828,3.389 -5.647,6.225 C -1.152,-17.2 -2.471,-9.39 0,0",
    style: {
      fill: "#b98b81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g104",
    transform: "translate(674.6865,592.7344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.49,-0.875 -9.846,-3.004 -15.464,-8.505 -8.757,-8.575 -12.857,-22.54 -8.505,-34.794 3.833,-10.793 12.772,-16.166 15.464,-17.784 5.758,-3.46 10.955,-4.406 12.371,-4.639 7.071,-1.16 12.832,0.209 15.85,1.16 0,0 -14.69,-28.608 -0.773,-53.35 0,0 -37.463,3.211 -59.848,31.451 -9.462,11.935 -13.195,27.385 -9.966,42.27 C -47.11,-26.849 -35.282,-4.78 0,0",
    style: {
      fill: "#656e7e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g108",
    transform: "translate(743.1143,324.0493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,7.732 -0.518,15.286 -1.516,22.616 v 0.008 c -6.471,47.667 -33.255,85.754 -70.778,99.154 -43.299,15.464 -63.402,42.526 -63.402,42.526 0,0 -17.992,21.262 -15.062,50.976 0.557,5.668 1.879,11.645 4.237,17.838 14.034,36.928 47.119,42.812 50.049,43.268 -8.041,-1.832 -94.917,-78.966 23.792,-133.345 C 47.165,88.144 0,0 0,0",
    style: {
      fill: "#ffd8be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g112",
    transform: "translate(741.5986,346.6729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -6.472,47.667 -33.255,85.755 -70.778,99.154 -43.299,15.464 -63.402,42.526 -63.402,42.526 0,0 -17.992,21.263 -15.062,50.977 l 0.008,0.008 c 0,0 -1.57,-43.64 44.048,-69.928 C -59.567,96.448 1.57,79.833 0,0",
    style: {
      fill: "#b99284",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g116",
    transform: "translate(529.3257,614.3838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0 22.423,-19.33 57.99,-17.783 0,0 -14.691,-6.186 -12.371,-13.918 0,0 -36.727,-4.253 -45.619,31.701",
    style: {
      fill: "#7d7b85",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g120",
    transform: "translate(603.5522,592.7344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0 -44.072,-45.619 -14.69,-101.289 29.381,-55.669 76.546,-47.938 99.742,-71.133 l -4.253,-7.346 c 0,0 -9.278,8.505 -25.515,10.052 -13.401,1.276 -26.539,8.759 -38.317,14.858 -35.196,18.224 -62.728,49.384 -59.269,91.294 1.143,13.844 5.691,27.351 13.509,38.862 C -22.417,-15.313 -13.192,-5.944 0,0",
    style: {
      fill: "#7d7b85",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g124",
    transform: "translate(648.7842,412.9663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0       C -41,-31 -102,-25.5 -102,-25.5       C -131,-24 -153,-15 -168,-3.5       C -197,18 -205,47 -205,47       C -140,-6 -35,10 -12,4       C -8,3 -4,1.5 0,0       Z",
    style: {
      fill: "#f5c9b4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path126"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g128",
    transform: "translate(648.7842,412.9663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -40.979,-30.928 -102.062,-25.515 -102.062,-25.515 -29.165,1.353 -50.451,10.577 -65.806,22.013 v 0.007 C -49.26,-35.992 -7.732,3.866 -7.732,3.866 Z",
    style: {
      fill: "#667088",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path130"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g132",
    transform: "translate(654.127,387.2349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -34.183,-33.928 -91.801,-52.546 -138.634,-36.943 -8.397,2.798 -16.314,7.159 -22.809,13.121 -2.513,2.296 -4.809,4.832 -6.843,7.615 -1.151,1.578 -5.358,12.449 -6.634,12.921 100.794,-36.921 185.466,25.492 185.466,25.492 l 3.619,-2.614 1.655,-1.198 C 16.376,18 1.508,1.5 0,0",
    style: {
      fill: "#f5c9b4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path134"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g136",
    transform: "translate(654.127,387.2349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -34.183,-33.928 -91.801,-52.546 -138.634,-36.943 -8.397,2.798 -16.314,7.159 -22.809,13.121 100.492,-33.72 175.608,43.414 175.608,43.414 L 15.82,18.394 C 16.376,18 1.508,1.5 0,0",
    style: {
      fill: "#667088",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path138"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g140",
    transform: "translate(708.8711,562.3843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-12.729 -10.318,-23.047 -23.047,-23.047 -12.728,0 -23.047,10.318 -23.047,23.047 0,12.729 10.319,23.047 23.047,23.047 C -10.318,23.047 0,12.729 0,0",
    style: {
      fill: "#f5c9b4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path142"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g144",
    transform: "translate(699.2495,562.3843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-7.415 -6.011,-13.425 -13.425,-13.425 -7.415,0 -13.426,6.01 -13.426,13.425 0,7.415 6.011,13.425 13.426,13.425 C -6.011,13.425 0,7.415 0,0",
    style: {
      fill: "#10192d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path146"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g148",
    transform: "translate(696.4663,567.7461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-3.708 -3.005,-6.713 -6.713,-6.713 -3.707,0 -6.712,3.005 -6.712,6.713 0,3.707 3.005,6.712 6.712,6.712 C -3.005,6.712 0,3.707 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path150"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g152",
    transform: "translate(698.0757,411.5903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0 -1.91,-7.732 -7.152,-19.175 -0.008,-0.024 -0.039,-0.077 -0.085,-0.17 -9.24,-20.119 -28.724,-51.557 -66.062,-72.657 -29.737,-16.81 -54.131,-14.599 -70.972,-8.32 -16.43,6.124 -25.669,16.129 -25.669,16.129 0,0 97.182,-11.575 166.267,87.51 z",
    style: {
      fill: "#f5c9b4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path154"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g156",
    transform: "translate(690.8384,392.2451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -9.24,-20.119 -28.724,-51.557 -66.062,-72.657 -29.737,-16.81 -54.131,-14.598 -70.971,-8.32 v 0.008 C -32.521,-58.299 -1.871,-3.518 0,0",
    style: {
      fill: "#667088",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path158"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g160",
    transform: "translate(710.9727,395.3765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0 -4.693,-126.186 -122.281,-107.041 0,0 28.392,8.458 58.732,31.507 19.925,15.139 40.685,36.573 54.796,66.039 2.173,4.531 4.183,9.255 6.016,14.181 z",
    style: {
      fill: "#fadac0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path162"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g164",
    transform: "translate(710.9727,395.3765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0 -4.693,-126.186 -122.281,-107.041 0,0 28.392,8.458 58.732,31.507 l 0.015,0.008 c 53.088,15.31 54.781,66.031 54.781,66.031 2.173,4.531 4.183,9.255 6.016,14.181 z",
    style: {
      fill: "#667088",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g168",
    transform: "translate(721.9082,379.3569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0 38.286,-93.76 -60.163,-103.917 0,0 58.601,25.002 60.163,103.917",
    style: {
      fill: "#667088",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path170"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.80b978ffec168c87d5fd468207666e47.svg";
export { ForwardRef as ReactComponent };